import angular from "angular";
import {APIs} from '@common/model/apis';
import {Util} from "@common/util";

export const API_TYPE = {
    API: '/api',
    PUBLIC: '/public'
}

export class APIService {
    endpoint = '';
    static $inject = ['$q', '$http', 'authConfig', 'CacheService', 'storageConfig', 'imgEnv'];

    constructor(private $q, private $http, authConfig, private cache, private storageConfig, private imgEnv) {
        this.endpoint = authConfig.backendEndPoint;
    }

    get(url: string, params: any = {}, isBckndApi: boolean = true) {
        let type = !!isBckndApi ? API_TYPE.API : '';
        return this.callApi(url, 'GET', null, params, type);
    }

    options(url: string, params: any = {}) {
        return this.callApi(url, 'OPTIONS', null, params);
    }

    delete(url: string, body: any = {}, params: any = {}) {
        return this.callApi(url, 'DELETE', {body}, params);
    }

    post(url: string, body: any = {}, params: any = {}, isBckndApi: boolean = true) {
        let type = !!isBckndApi ? API_TYPE.API : '';
        return this.callApi(url, 'POST', body, params, type);
    }

    put(url: string, body: any = {}, params: any = {}) {
        return this.callApi(url, 'PUT', body, params);
    }

    patch(url: string, body: any = {}, params: any = {}) {
        return this.callApi(url, 'PATCH', body, params);
    }

    reportError(params, resBody, resp, method) {
        const message = {
            'params': params,
            'body': resBody,
            'resp': resp,
            'method': method
        }
        var deferred = this.$q.defer();
        try {
            var body = {};
            body['message'] = btoa(JSON.stringify(message));
            this.post(APIs.LOG_ERROR, body).then((success: any) => {
                console.log('logged', body);
                Util.objectUnEscape(success.data);
                deferred.resolve();
            }).catch(() => {
                deferred.resolve();
            });
        } catch (e) {
            console.log(e, message);
            return;
        }

        return deferred.promise;
    }

    getImageUrl = (type, imageName) => {
        const sassData = this.cache.getSASSToken();
        return `${this.storageConfig.url}/${this.storageConfig.buckets.ecvImages}/${this.imgEnv}/${type}/${imageName}?${sassData.sasToken}`;
    }

    signImages = (obj) => {
        for (var i in obj) {
            if (obj.hasOwnProperty(i)) {
                if (typeof (obj[i]) == 'object' || Array.isArray(obj[i]))
                    this.signImages(obj[i]);

                if (typeof (obj[i]) == 'string' && !!obj[i] &&
                    !obj[i].includes("googleusercontent.com") &&
                    !obj[i].includes("licdn.com")) {
                    if (['photo', 'senderPhoto', 'inviterPhoto'].includes(i)) {
                        obj[i] = this.getImageUrl('mugshots', obj[i]);
                    } else if (i == 'thumbnail') {
                        obj[i] = this.getImageUrl('thumbnails', obj[i]);
                    }
                }
            }
        }
    }

    handleQueryParams = function (obj) {
        let rtnStr = '';
        if (obj) {
            var str = [];
            for (var p in obj) {
                if (obj.hasOwnProperty(p)) {
                    str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
                }
            }

            if (str.length > 0) {
                rtnStr = '?' + str.join("&");
            }
        }
        return rtnStr;
    }

    callApi(
        path: string,
        method: 'GET' | 'OPTIONS' | 'DELETE' | 'POST' | 'PUT' | 'PATCH',
        body: any,
        queryParams?: any,
        type: string = API_TYPE.API
    ) {
        let callArry: string[];
        let deferred = this.$q.defer();
        let url = `${this.endpoint}${type}${path}`;

        switch (method) {
            case 'GET':
            case 'OPTIONS':
                url = `${url}${this.handleQueryParams(queryParams)}`;
                callArry = [url];
                break;
            case 'DELETE':
            case 'POST':
            case 'PATCH':
            case 'PUT':
                url = `${url}${this.handleQueryParams(queryParams)}`;
                callArry = [url, body];
                break;
            default:
                throw new Error('Invalid HTTP Method');
        }

        this.$http[method.toLowerCase()]
            .apply(this.$http, callArry).then((success) => {
            Util.objectUnEscape(success.data);
            this.signImages(success.data);
            if (!!success.data && !!success.data.errorMessage) {
                this.reportError(queryParams, body, success, method);
                let errorMsg = (success.data.errorMessage.indexOf(':') != -1) ? success.data.errorMessage.split(':')[1] : success.data.errorMessage;
                deferred.reject(errorMsg);
            } else {
                deferred.resolve(success.data);
            }
        }).catch((error) => {
            if (path.indexOf(APIs.LOG_ERROR) == -1) {
                this.reportError(queryParams, body, error, method);
            }
            let errMsg;
            if (!!error.data && !!error.data.errorMessages && error.data.errorMessages.length > 0) {
                errMsg = error.data.errorMessages[0];
            } else if (error.status == 403 && (!!error.data && error.data.message && error.data.message.indexOf('request is expired') > -1)) {
                errMsg = {'error': error, 'message': 'Please login in again'};
            } else if ((error.status == 401 || error.status == 502) && (!!error.data && error.data.message && error.data.message.indexOf(':') != -1)) {
                errMsg = error.data.message.split(':')[1];
            } else if ((error.status == 404 && path.indexOf(APIs.GET_IDENTITY) > -1) || error.status == 412) {
                errMsg = error;
            } else if (!!error.data && !!error.data.errorMessage && error.data.errorMessage.indexOf(':') != -1) {
                errMsg = error.data.errorMessage.split(':')[1];
            } else if (error.status === 510 && (error.data.length > 0)) {
                errMsg = error.data;
            } else if (error.status == 400 && !!error.data && !!error.data.errors && error.data.errors.length > 0) {
                errMsg = error.data.errors;
            } else {
                var e;
                !!error.data && (e = error.data.errorMessage);
                if (!e) {
                    e = "Something went wrong, please try again."
                }
                errMsg = e;
            }
            deferred.reject(errMsg);
        });

        return deferred.promise;
    }
}

angular.module('eCareVault.common.APIService').service('APIService', APIService);
